import moment from "moment";

const getFormatedDate = {
  methods: {
    getFormatedDate(val, format) {
      const formatTemplate = format;
      const timeFormat = moment(val);
      const finalValue = timeFormat.format(formatTemplate);
      return finalValue;
    },
  },
};

export { getFormatedDate };
